module.exports = __webpack_public_path__ + "img/_device-laptop.f96af088.png";